import { Action } from '@ngrx/store';

export enum VttActionTypes {
  LOAD = '[VTT] Load',
  LOAD_SUCCESS = '[VTT] Load Success',
  LOAD_FAIL = '[VTT] Load Fail',

  ADD = '[VTT] Add',
  ADD_SUCCESS = '[VTT] Add Success',
  ADD_FAIL = '[VTT] Add Fail',

  EDIT = '[VTT] Edit',
  EDIT_SUCCESS = '[VTT] Edit Success',
  EDIT_FAIL = '[VTT] Edit Fail',

  DELETE = '[VTT] Delete',
  DELETE_SUCCESS = '[VTT] Delete Success',
  DELETE_FAIL = '[VTT] Delete Fail',
}

/** Load VTT files */
export class LoadVtt implements Action {
  readonly type = VttActionTypes.LOAD;
  constructor(public companyId: number, public asset_id:any) {}
}

export class LoadVttSuccess implements Action {
  readonly type = VttActionTypes.LOAD_SUCCESS;
  constructor(public response: any) {}
}

export class LoadVttFail implements Action {
  readonly type = VttActionTypes.LOAD_FAIL;
  constructor(public error: any) {}
}

/** Add new VTT */
export class AddVtt implements Action {
  readonly type = VttActionTypes.ADD;
  constructor(public companyId: number, public asset_id:any, public payload: any) {}
}

export class AddVttSuccess implements Action {
  readonly type = VttActionTypes.ADD_SUCCESS;
}

export class AddVttFail implements Action {
  readonly type = VttActionTypes.ADD_FAIL;
  constructor(public error: any) {}
}

/** Edit existing VTT */
export class EditVtt implements Action {
  readonly type = VttActionTypes.EDIT;
  constructor(public companyId: number, public asset_id: any, public payload: any) {}
}

export class EditVttSuccess implements Action {
  readonly type = VttActionTypes.EDIT_SUCCESS;
  constructor(public response: any) {}
}

export class EditVttFail implements Action {
  readonly type = VttActionTypes.EDIT_FAIL;
  constructor(public error: any) {}
}

/** Delete VTT */
export class DeleteVtt implements Action {
  readonly type = VttActionTypes.DELETE;
  constructor(public companyId: number, public asset_id: any, public track_id:any) {}
}

export class DeleteVttSuccess implements Action {
  readonly type = VttActionTypes.DELETE_SUCCESS;
}

export class DeleteVttFail implements Action {
  readonly type = VttActionTypes.DELETE_FAIL;
  constructor(public error: any) {}
}

export type VttActions =
  | LoadVtt
  | LoadVttSuccess
  | LoadVttFail
  | AddVtt
  | AddVttSuccess
  | AddVttFail
  | EditVtt
  | EditVttSuccess
  | EditVttFail
  | DeleteVtt
  | DeleteVttSuccess
  | DeleteVttFail;
